import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { goBackAction } from "./actions";
import { StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { onChangeDimension } from "../cgtcInit/actions";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
import { VOLT_ERROR_CODE } from "../../configs/constants";
export const template = (height) => ({
    layout: {
        id: ROUTE.CGTC_PROGRESS,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'cgtcProgressRootContainer', type: WIDGET.STACK },
        ],
    },
    datastore: {
        cgtcProgressRootContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'cgtcProgressPage', type: WIDGET.CGTC_PROGRESS }
            ],
            dimensionAction: {
                type: ACTION.ON_CHANGE_DIMENSION,
                routeId: ROUTE.CGTC_PROGRESS,
                payload: {}
            }
        },
        cgtcProgressPage: {
            show: true,
            cancelAction: {
                routeId: ROUTE.CGTC_PROGRESS,
                type: ACTION.GO_BACK,
                payload: {}
            }
        }
    },
});
export const cgtcProgressMF = {
    onLoad: async ({ getHeight, network, navigateToBase, ...props }) => {
        // -------------- POLLING API ---------------- //
        const cgsUserContext = await sharedPropsService.getCgtcUserContext();
        const toDate = cgsUserContext?.toDate;
        const fromDate = cgsUserContext?.fromDate;
        const interval = setInterval(async () => {
            await network.get(`${api.mfcCgsDetailPoll}?financialYearEndDate=${toDate}&financialYearStartDate=${fromDate}`, {
                headers: await getAppHeader()
            }, async () => { return; }, {
                isPartnerPlatform: true
            }).then(async (res) => {
                if (res?.status === 200) {
                    clearInterval(interval);
                    const data = res?.data;
                    const userContext = await sharedPropsService.getCgtcUserContext();
                    await sharedPropsService.setCgtcUserContext({
                        ...userContext,
                        cgsData: data
                    });
                    await navigateToBase(ROUTE.CGTC_SUMMARY);
                }
                else if (res?.response?.status === 400 &&
                    res?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PORTFOLIO_RESPONSE_PENDING) {
                    //Keep on polling
                }
                else if (res?.response?.status === 400 &&
                    res?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PORTFOLIO_NOT_FOUND) {
                    clearInterval(interval);
                    navigateToBase(ROUTE.CGTC_NO_PORTFOLIO);
                }
            });
        }, 5000);
        // ------------------------------------------- //
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension
    },
    clearPrevious: true,
};
